import { Directive, ElementRef, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
    selector: '[testId]',
    standalone: true
})
export class TestIdDirective {
  @Input() set testId(value: string) {
    if (environment.production || !value) {
      return;
    }
    const nativeElement = this.el.nativeElement;
    nativeElement.setAttribute('data-cy', value);
  }

  constructor(private el: ElementRef) {}
}
